import { getStoredToken } from "../../../services/api";
import { API_BASE_URL } from "../../../config/api";
import { createApiError } from "../../../utils/errorHandling";

export type ContactEntityType = "customer" | "vendor";

export async function deleteZohoContact(params: {
  zohoContactId: string;
  entityType: ContactEntityType;
  entityId: number;
  skipReviewRequest?: boolean;
  reviewId?: number;
}): Promise<{ success: boolean; message?: string }> {
  const token = getStoredToken();
  const body: Record<string, unknown> = {
    entity_type: params.entityType,
    entity_id: params.entityId,
    skip_review_request: Boolean(params.skipReviewRequest),
  };
  if (params.reviewId != null && params.reviewId > 0) {
    body.review_id = params.reviewId;
  }

  const response = await fetch(
    `${API_BASE_URL}/api/contacts/${encodeURIComponent(params.zohoContactId)}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    },
  );

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const err = createApiError(
      (payload as { message?: string }).message ||
        "Failed to delete contact",
      response.status,
      response.statusText,
    );
    const code = (payload as { code?: string }).code;
    if (code) {
      (err as Error & { code?: string }).code = code;
    }
    throw err;
  }

  return payload as { success: boolean; message?: string };
}
